import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PulseLoader } from "react-spinners";
import { ToastContainer } from "react-toastify";
import { createUser, getUser, getAllEvents, getAllVenueBySlug, deleteUser, updateUser } from "../../api";
import ListCard from "../../components/common/ListCard/ListCard";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { useAuth } from "../../context/AuthContext";

const userTypeToRole: Record<string, number> = {
  scanner: 4,
  "second-admin": 2,
  venue: 4,
};

const AddSubUser = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [users, setUsers] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [eventsList, setEventsList] = useState<any[]>([]);
  const [eventVenuesForAdd, setEventVenuesForAdd] = useState<any[]>([]);
  const [editModal, setEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [showPassword, setShowPassword] = useState(false);
  const [organizerId, setOrganizerId] = useState<string>("");
  const { user, isAuthenticated, refreshUser } = useAuth();

  const toggleEditModal = () => setEditModal((prev) => !prev);

  useEffect(() => {
    const venueOrganizerData = localStorage.getItem("venueOrganizerData");
    if (venueOrganizerData) {
      setOrganizerId(JSON.parse(venueOrganizerData).organizerId);
    }
    getUserList();
    // if (modal) getOnlyOrganizerEvents();
  }, [modal]);



  const getUserList = async () => {
    setIsLoading(true);
    try {
      if (organizerId) {
        const response = await getUser(organizerId);
        if (response)
          setUsers(response);
      }
    } catch {}
    setIsLoading(false);
  };

//   const getOnlyOrganizerEvents = async () => {
//     setEventsList([]);
//     setEventVenuesForAdd([]);
//     try {
//       const events = await();
//       setEventsList(
//         Array.isArray(events)
//           ? events.filter((e: any) => String(e.organizerId) === String(organizerId))
//           : []
//       );
//     } catch {}
//   };

  const handleRoleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue("role", Number(e.target.value));
    // Reset event and venue selections on role change
    formik.setFieldValue("eventId", "");
    formik.setFieldValue("venueId", "");
    setEventVenuesForAdd([]);
  };

 

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phoneNo: "",
      role: "",
      eventId: "",
      venueId: "",
      password: "",
      status: "active"
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      phoneNo: Yup.string().required("Phone number is required"),
      role: Yup.number()
        .required("Role is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters long")
        .required("Password is required"),
     
    }),
    onSubmit: async (values) => {
      try {
        if (organizerId) {
          const payload: any = {
            organizerId: organizerId,
            name: values.name,
            email: values.email,
            username: values.email,
            phoneNo: values.phoneNo,
            password: values.password,
            status: values.status,
            role: userTypeToRole[values.role] || 4,
            eventId: values.eventId
          };
          if (values.role === "venue") payload.venueId = values.venueId;

          await createUser(organizerId,payload);
          toast.success("User added successfully");
          setModal(false);
        //   getUserList();
          formik.resetForm();
          setEventVenuesForAdd([]);
        } else {
          toast.error("Missing organizer data");
        }
      } catch (error:any) {
        toast.error(error?.response?.data?.message || "Failed to add user");
      }
    }
  });

  const editFormik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phoneNo: "",
      role: "",
      eventId: "",
      venueId: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      phoneNo: Yup.string().required("Phone number is required"),
      status: Yup.string()
        .oneOf(["active", "inactive"], "Invalid status")
        .required("Status is required")
    }),
    onSubmit: async (values) => {
      try {
        if (!selectedUser) return;
        const payload = {
          name: values.name,
          email: values.email,
          phoneNo: values.phoneNo,
          role: userTypeToRole[values.role] || 4,
          eventId: values.eventId,
          venueId: values.venueId || null,
        };
        await updateUser(selectedUser.userId, payload);
        toast.success("User updated successfully");
        toggleEditModal();
        getUserList();
      } catch (error) {
        toast.error("Failed to update user");
      }
    }
  });

  const getRoleDisplay = (user: any) => {
    const userRole = String(user.userRole);
    if (userRole === "4") return "Scanner Boy";
    if (userRole === "2") return "Second Admin";
    if (userRole === "3") return "Venue";
    return "N/A";
  };

  return (
    <div className="dashboard-body">
      <div className="container-fluid">
        <ToastContainer autoClose={2000} />
        <div className="row">
          <div className="col-md-12">
            <div className="d-main-title">
              <h3>
                <i className="mx-2">
                  <i className="fa-solid fa-user-plus"></i>
                </i>
                Add Sub User
              </h3>
            </div>
          </div>
          <div className="col-md-12">
            <div className="main-card mt-5">
              <div className="dashboard-wrap-content p-2">
                <div className="d-md-flex flex-wrap align-items-center">
                  <div className="rs ms-auto m-2 mt_r4">
                    <Button color="danger" onClick={toggle}>
                      <i className="fa-solid fa-plus"></i>
                      <span className="me-2"> New Sub User</span>
                    </Button>
                    <Modal isOpen={modal} toggle={toggle}>
                      <ModalHeader toggle={toggle}>Add New Sub User</ModalHeader>
                      <ModalBody className="p-4">
                        <Form onSubmit={formik.handleSubmit}>
                          <FormGroup>
                            <Label for="name">Name</Label>
                            <Input
                              type="text"
                              name="name"
                              id="name"
                              placeholder="Enter user name"
                              value={formik.values.name}
                              onChange={formik.handleChange}
                              invalid={formik.touched.name && !!formik.errors.name}
                            />
                            <FormFeedback>{formik.errors.name}</FormFeedback>
                          </FormGroup>
                          <FormGroup>
                            <Label for="email">Email</Label>
                            <Input
                              type="email"
                              name="email"
                              id="email"
                              placeholder="Enter user email"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              invalid={formik.touched.email && !!formik.errors.email}
                            />
                            <FormFeedback>{formik.errors.email}</FormFeedback>
                          </FormGroup>
                          <FormGroup>
                            <Label for="phoneNo">Phone Number</Label>
                            <Input
                              type="text"
                              name="phoneNo"
                              id="phoneNo"
                              placeholder="Enter phone number"
                              value={formik.values.phoneNo}
                              onChange={formik.handleChange}
                              invalid={formik.touched.phoneNo && !!formik.errors.phoneNo}
                            />
                            <FormFeedback>{formik.errors.phoneNo}</FormFeedback>
                          </FormGroup>
                          <FormGroup>
                            <Label for="role">Role</Label>
                            <Input
                              type="select"
                              name="role"
                              id="role"
                              value={formik.values.role}
                              onChange={handleRoleChange}
                              invalid={formik.touched.role && !!formik.errors.role}
                            >
                              <option value="">Select a role</option>
                              <option value="4">Scanner Boy</option>
                              <option value="2">Second Admin</option>
                              <option value="3">Venue</option>
                            </Input>
                            <FormFeedback>{formik.errors.role}</FormFeedback>
                          </FormGroup>

                          {/* {(formik.values.role === "scanner" ||
                            formik.values.role === "second-admin" ||
                            formik.values.role === "venue") && (
                            <FormGroup>
                              <Label for="eventId">Event</Label>
                              <Input
                                type="select"
                                name="eventId"
                                id="eventId"
                                value={formik.values.eventId}
                                onChange={handleEventChange}
                                invalid={formik.touched.eventId && !!formik.errors.eventId}
                              >
                                <option value="">Select an event</option>
                                {eventsList.map((event: any) => (
                                  <option key={event.eventId} value={event.eventId}>
                                    {event.eventName}
                                  </option>
                                ))}
                              </Input>
                              <FormFeedback>{formik.errors.eventId}</FormFeedback>
                            </FormGroup>
                          )}

                          {formik.values.role === "venue" &&
                            formik.values.eventId &&
                            eventVenuesForAdd.length > 0 && (
                              <FormGroup>
                                <Label for="venueId">Venue</Label>
                                <Input
                                  type="select"
                                  name="venueId"
                                  id="venueId"
                                  value={formik.values.venueId}
                                  onChange={formik.handleChange}
                                  invalid={formik.touched.venueId && !!formik.errors.venueId}
                                >
                                  <option value="">Select a venue</option>
                                  {eventVenuesForAdd.map((venue: any) => (
                                    <option key={venue.value} value={venue.value}>{venue.label}</option>
                                  ))}
                                </Input>
                                <FormFeedback>{formik.errors.venueId}</FormFeedback>
                              </FormGroup>
                            )} */}

                          <FormGroup>
                            <Label for="password">Password</Label>
                            <div className="position-relative">
                              <Input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                id="password"
                                placeholder="Enter password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                invalid={formik.touched.password && !!formik.errors.password}
                              />
                              <i
                                className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} position-absolute`}
                                style={{
                                  top: "50%",
                                  right: "10px",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                  color: "#888"
                                }}
                                onClick={() => setShowPassword(!showPassword)}
                                title={showPassword ? "Hide Password" : "Show Password"}
                              ></i>
                            </div>
                            <FormFeedback>{formik.errors.password}</FormFeedback>
                          </FormGroup>
                          <ModalFooter>
                            <Button color="primary" type="submit">{isLoading ? <PulseLoader color="#ffffff" size={9} speedMultiplier={1} /> : "Add User"}</Button>
                          </ModalFooter>
                        </Form>
                      </ModalBody>
                    </Modal>
                    {/* === Edit Sub User Modal === */}
<Modal isOpen={editModal} toggle={toggleEditModal}>
  <ModalHeader toggle={toggleEditModal}>Edit Sub User</ModalHeader>
  <ModalBody className="p-4">
    <Form onSubmit={editFormik.handleSubmit}>
      <FormGroup>
        <Label for="name">Name</Label>
        <Input
          type="text"
          name="name"
          id="name"
          value={editFormik.values.name}
          onChange={editFormik.handleChange}
        />
      </FormGroup>

      <FormGroup>
        <Label for="email">Email</Label>
        <Input
          type="email"
          name="email"
          id="email"
          value={editFormik.values.email}
          onChange={editFormik.handleChange}
        />
      </FormGroup>

      <FormGroup>
        <Label for="phoneNo">Phone Number</Label>
        <Input
          type="text"
          name="phoneNo"
          id="phoneNo"
          value={editFormik.values.phoneNo}
          onChange={editFormik.handleChange}
        />
      </FormGroup>

      <FormGroup>
        <Label for="role">Role</Label>
        <Input
          type="select"
          name="role"
          id="role"
          value={editFormik.values.role}
          onChange={(e) => {
            editFormik.handleChange(e);
            editFormik.setFieldValue("eventId", "");
            editFormik.setFieldValue("venueId", "");
          }}
        >
          <option value="">Select Role</option>
          <option value="scanner">Scanner Boy</option>
          <option value="second-admin">Second Admin</option>
          {/* <option value="venue">Venue</option> */}
        </Input>
      </FormGroup>

      {/* {(editFormik.values.role === "scanner" ||
        editFormik.values.role === "second-admin" ||
        editFormik.values.role === "venue") && (
        <FormGroup>
          <Label for="eventId">Event</Label>
          <Input
            type="select"
            name="eventId"
            id="eventId"
            value={editFormik.values.eventId}
            onChange={async (e) => {
              const eventId = e.target.value;
              editFormik.setFieldValue("eventId", eventId);
              if (editFormik.values.role === "venue" && eventId) {
                const event = eventsList.find((ev) => ev.eventId === eventId);
                if (event) {
                  try {
                    const resp = await getAllVenueBySlug(event.slugId);
                    setEventVenuesForAdd(
                      Array.isArray(resp)
                        ? resp.map((v) => ({ value: v.venueId, label: v.venueName }))
                        : []
                    );
                  } catch {
                    setEventVenuesForAdd([]);
                  }
                }
              }
            }}
          >
            <option value="">Select an event</option>
            {eventsList.map((event) => (
              <option key={event.eventId} value={event.eventId}>
                {event.eventName}
              </option>
            ))}
          </Input>
        </FormGroup>
      )}

      {editFormik.values.role === "venue" &&
        editFormik.values.eventId &&
        eventVenuesForAdd.length > 0 && (
          <FormGroup>
            <Label for="venueId">Venue</Label>
            <Input
              type="select"
              name="venueId"
              id="venueId"
              value={editFormik.values.venueId}
              onChange={editFormik.handleChange}
            >
              <option value="">Select a venue</option>
              {eventVenuesForAdd.map((venue) => (
                <option key={venue.value} value={venue.value}>
                  {venue.label}
                </option>
              ))}
            </Input>
          </FormGroup>
        )} */}

      <ModalFooter>
        <Button color="primary" type="submit">
          Update User
        </Button>
        <Button color="secondary" onClick={toggleEditModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Form>
  </ModalBody>
</Modal>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4">
                {isLoading ? (
                  <div className="d-flex justify-content-center py-4">
                    <PulseLoader color="#ffffff" size={9} speedMultiplier={1} />
                  </div>
                ) : users.length === 0 ? (
                  <p className="text-center w-100">No users found.</p>
                ) : (
                  users.map((item: any) => (
                    <div key={item.userId}>
                      <ListCard
                        cardData={{
                          name: item.name,
                          icon: "fa-solid fa-user",
                          ticket: item.email,
                          startDate: item.createdAt,
                          status: item.status,
                          description: item.phoneNo,
                          optionHead: "Role",
                          option: getRoleDisplay(item),
                        }}
                        onEdit={() => {
                          setSelectedUser(item);
                          editFormik.setValues({
                            name: item.name || "",
                            email: item.email || "",
                            phoneNo: item.phoneNo || "",
                            role: item.userRole === "4" ? "scanner" : "second-admin",
                            eventId: item.eventId || "",
                            venueId: item.venueId || "",
                          });
                          toggleEditModal();
                        }}
                        onDelete={async () => {
                          if (window.confirm("Are you sure you want to delete this user?")) {
                            try {
                            //   await deleteUser(item.userId);
                              toast.success("User deleted successfully");
                            //   getUserList();
                            } catch (error) {
                              toast.error("Failed to delete user");
                            }
                          }
                        }}
                      />
                    </div>
                  ))
                )}
              </div>
      </div>
    </div>
  );

};

export default AddSubUser;
